import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e86c478"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout-insurance__section" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col--12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "xhtml" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Extend insurance"),
    /*#__PURE__*/_createElementVNode("p", null, "You have extended your travel and your current booking has insurance on some of its travelers. Do you want to extend the insurance to cover your new travel dates?")
  ])
], -1))
const _hoisted_4 = { class: "col--12" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Do you want to extend the insurance?", -1))
const _hoisted_6 = {
  key: 0,
  class: "col--12 input-field__error"
}
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseRadio = _resolveComponent("BaseRadio")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_BaseRadio, {
          id: "i-opt-1-extend",
          name: "extend",
          label: "Yes",
          value: true,
          modelValue: _ctx.extendInsuranceInput,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.extendInsuranceInput) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_BaseRadio, {
          id: "i-opt-2-extend",
          name: "extend",
          label: "No",
          value: false,
          modelValue: _ctx.extendInsuranceInput,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.extendInsuranceInput) = $event))
        }, null, 8, ["modelValue"])
      ]),
      (_ctx.v$.extendInsurance.$errors.length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.extendInsurance.$errors, (error) => {
              return (_openBlock(), _createElementBlock("li", {
                key: error,
                innerHTML: error.$message
              }, null, 8, _hoisted_7))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}